import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function PainPoints() {
  return <section className="py-10 md:py-20 px-5 md:px-6 bg-white" data-id="element-122">
      <div className="max-w-4xl mx-auto" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-124">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-[#2D1F1A] leading-tight tracking-tight" data-id="element-125">
            ¿Te <em className="text-[#F9A8B7] not-italic" data-id="element-126">reconoces</em> en
            alguna de estas madres?
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="rounded-3xl overflow-hidden shadow-xl border border-[#F9A8B7]/20" data-id="element-127">
          <img src="https://cdn.magicpatterns.com/uploads/fv2vurzt58pkebF2JTSXtx/landing_4_imagenes.png" alt="Cuatro situaciones reales de mamás: se siente perdida, sueña con que coma sano, vive con miedo, está harta de improvisar" loading="lazy" className="w-full h-auto block" data-id="element-128" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="mt-8 md:mt-12 p-5 md:p-7 bg-[#A9D7E2]/20 rounded-2xl border-2 border-[#A9D7E2]/40 flex items-start gap-3 md:gap-4" data-id="element-129">
          <div className="flex-shrink-0 mt-1" data-id="element-130">
            <div className="bg-[#A9D7E2] p-1.5 rounded-full" data-id="element-131">
              <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-white" strokeWidth={3} data-id="element-132" />
            </div>
          </div>
          <p className="text-lg md:text-2xl font-bold text-[#2D1F1A] leading-snug" data-id="element-133">
            Si te viste reflejada en{' '}
            <span className="underline decoration-[#A9D7E2] decoration-4 underline-offset-4" data-id="element-134">
              al menos una
            </span>
            ,{' '}
            <em className="text-[#F9A8B7] not-italic" data-id="element-135">
              esta página es para ti.
            </em>
          </p>
        </motion.div>
      </div>
    </section>;
}